module.exports = __webpack_public_path__ + "static/img/in-premier-insurance.dd8973a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/in-premier-insurance.png
// module id = 0DAg
// module chunks = 1